
import { ReactNode } from "react";
import AdminHeader from "../header/AdminHeader";
import Footer from "../footer/Footer";

interface AdminLayoutProps {
  children: ReactNode;
}

const AdminLayout = ({ children }: AdminLayoutProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 relative overflow-hidden" dir="rtl">
      {/* خلفية ثابتة بدون حركة */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-muted/20 to-background"></div>
      
      {/* Subtle dot pattern overlay */}
      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" 
           style={{
             backgroundImage: `radial-gradient(circle at 2px 2px, hsl(var(--school-navy)) 1px, transparent 0)`,
             backgroundSize: '40px 40px'
           }}>
      </div>
      
      {/* Gradient mesh overlay */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-gradient-to-br from-transparent via-school-green/10 to-transparent"></div>
      
      {/* Layout structure without sidebar */}
      <div className="relative min-h-screen w-full z-10">
        <AdminHeader />
        <main className="flex-1 backdrop-blur-[0.5px] p-4">
          <div className="max-w-full">
            {children}
          </div>
        </main>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default AdminLayout;
